export default __webpack_public_path__ + "static/media/profile.3b98e9c3.png";